/**
* Project Name : cop-web-portal
* File Name : LoginPage.vue
* Description : Login page
* Date : 2023.05.12
*/
<template>
  <div>
    <!--
    <div class="ui--form-login login-info" v-if="errorState.code === 'authOk'">
      <header class="mb-4">
        <img :src="$CONTEXT + '/static/image/main/simbol.png'" class="mb-3 ui--brand-simbol" alt="System Simbol">
        <span class="brand-text">{{title}}</span>
      </header>
      <hr class="mb-4">
      <dl class="row">
        <dt class="col-6 text-right">Current Connection IP</dt>
        <dd class="col-6 text-left">!!</dd>
        <dt class="col-6 text-right">Last Connection IP</dt>
        <dd class="col-6 text-left">!!</dd>
        <dt class="col-6 text-right">Last Login Time</dt>
        <dd class="col-6 text-left">Wed Feb 12 15:24:41 KST 2014</dd>
      </dl>
      <button class="btn btn-lg btn-secondary" type="button" @click="gotoMain">{{title}} 바로가기</button>
    </div>
    -->
    <!-- <div class="loader" v-if="isLoaderVisible">
      <div class="sdl-center wd-3" style="width:610px;">
        <div class="msg-box">
          <div class="msg-icon"><em class="icon-info text-warning icon-size-2"></em></div>
          <div class="msg-text">
            <h3 class="mb-4">Information Message</h3>
            <strong class="d-block mb-3">{{ $t('sdl.common.message.initLoadingMsg') }}</strong>
            <ol class="list-unstyled">
              <li>{{ $t('sdl.common.message.browserInfo1') }}</li>
              <li>{{ $t('sdl.common.message.browserInfo2') }}</li>
              <li>{{ $t('sdl.common.message.browserInfo3') }}</li>
              <li>{{ $t('sdl.common.message.browserInfo4') }}</li>
            </ol>
          </div>
        </div>
      </div>

      <footer class="ui--footer-container">
        <div class="ui--footer-in">
          <span>&copy; Samsung</span>
        </div>
      </footer>
    </div>
    <div style="width:100%" v-else-if="errorState.code !== '196'">
      <form class="ui--form-login" @submit.prevent @keyup.enter="handleSubmit">
        <header class="mb-4">
          <img :src="$CONTEXT + '/static/image/main/simbol.png'" class="mb-3 ui--brand-simbol" alt="System Simbol" />
          <span class="brand-text">{{ title }}</span>
        </header>
        <label for="inputID" class="sr-only">ID</label>
        <input
          type="text"
          id="inputID"
          class="form-control ui--login-id"
          placeholder="ID"
          required
          autofocus
          v-model="userId"
        />
        <label for="inputPassword" class="sr-only">Password </label>
        <input
          type="password"
          id="inputPassword"
          class="form-control ui--login-pass"
          placeholder="Password"
          required
          v-model="password"
        />
        <div class="checkbox mb-3">
          <label><input type="checkbox" v-model="rememberMe" /> Remember ID </label>
        </div>
        <button class="btn btn-lg btn-primary btn-block" type="button" @click="handleSubmit()">Login</button>
        <button class="btn btn-lg btn-outline-secondary btn-block" type="button" @click="loginByAd()">
          AD SSO Login
        </button>
        <button class="btn btn-lg btn-outline-secondary btn-block" type="button" @click="loginByNewEpTray()">
          New EpTray Login
        </button>
        <p class="mt-3">
          <router-link :to="$CONTEXT + '/register'">{{ $t('sdl.common.label.membership') }}</router-link
          >&nbsp;&nbsp;|&nbsp;&nbsp;<router-link :to="$CONTEXT + '/initPassword'">
            {{ $t('sdl.common.label.initPassword') }}
          </router-link>
        </p>
      </form>
    </div>
    <div class="ui--form-login login-info" v-else>
      <header class="mb-4">
        <img :src="$CONTEXT + '/static/image/main/simbol.png'" class="mb-3 ui--brand-simbol" alt="System Simbol" />
        <span class="brand-text">{{ title }}</span>
      </header>
      <hr class="mb-4" />
      <div class="message">
        <p v-html="$t('sdl.common.label.selectRole')"></p>
        <div class="file-list bg-white mb-3">
          <ul>
            <li v-for="(role, index) in roleList" :key="index">
              <div class="form-check text-left">
                <label class="form-check-label"
                  ><input type="checkbox" class="form-check-input" v-model="role.selected" /> {{ role.roleName }}</label
                >
              </div>
            </li>
          </ul>
        </div>
      </div>

      <button class="btn btn-lg btn-primary" type="button" @click="signonReg">
        {{ $t('sdl.identity.label.userRegistration') }}
      </button>
    </div> -->
    <!-- Footer -->
    <!-- <footer class="ui--footer-container" v-if="!isLoaderVisible">
      <p class="text-muted">
        {{ $t('sdl.common.message.onlyAuthUserLegalSanctions') }}
      </p>
      <span>&copy; Samsung</span>
    </footer> -->
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import SDLUtil from '@/utils/SDLUtil';
import loginService from '@/service/loginService';
import {MFAUtil} from "@/utils";

export default {
  data() {
    return {
      title: SDLUtil.getMsgProp('sdl.common.projectName'),
      userId: 'admin',
      password: '',
      rememberMe: false,
      submitted: false,
      roleList: [],
      isLoaderVisible: true,
      websocket: null,
      newEpTrayKey: null,
    };
  },
  methods: {
    ...mapActions(['login', 'logout', 'loginNewEpTray']),
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: 로그인 폼 submit (submit login form)
     * since: 2023.05.12
     */
    async handleSubmit() {
      // SDLUtil.alert({ msg: 'sdp.currency.exchRate.gdatu' });
      this.submitted = true;
      const { userId, password } = this;
      if (userId && password) {
        const loginResult = await this.login({ userId: this.userId, password: this.password });
        this.afterLoginProcess(loginResult);
      }
    },
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: AD 로그인 (login with AD)
     * since: 2023.05.12
     */
    loginByAd() {
      const redirect = this.$route.query.redirect || '';
      if (redirect) {
        window.location.href = `${SDLUtil.API_URL}/noauth/saml-request?redirect=${redirect}`;
      } else {
        window.location.href = `${SDLUtil.API_URL}/noauth/saml-request`;
      }
    },
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: EpTray 로그인 (login with EpTray)
     * since: 2023.05.12
     */
    async loginByNewEpTray() {
      let loginResult = false;
      SDLUtil.showLoadingBar(true);
      await this.socConnect().then((data) => {
        this.newEpTrayKey = data;
        this.websocket.close();
      }).catch((err) => {
        SDLUtil.alert(err);
      });
      SDLUtil.showLoadingBar(false);

      if (this.newEpTrayKey) {
        if (this.newEpTrayKey.result === 'success') {
          const { userInfo, key } = this.newEpTrayKey;
          loginResult = await this.loginNewEpTray({ userInfo, key });
        } else {
          SDLUtil.alert(`sdl.epTray.error.${this.newEpTrayKey.errorCode}`);
        }
      }

      if (!loginResult) {
        if (this.$route.query.token) {
          loginService.setToken(this.$route.query.token);
          document.location = `${SDLUtil.WEB_CONTEXT_PATH}/`;
        }
      }
      this.afterLoginProcess(loginResult);
    },
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: 로그인 후처리 (post process after login)
     * since: 2023.05.12
     */
    afterLoginProcess(loginResult) {
      // console.log('LoginPage:', loginResult);
      if (loginResult) {
        // console.log('userInfo:', SDLUtil.getLoginedUserInfo());
        // this.$store.commit('ERROR_STATE', { code: 'authOk' });
        if (this.rememberMe) {
          localStorage.setItem('rememberMe', 'true');
          localStorage.setItem('rememberId', this.userId);
        } else {
          localStorage.removeItem('rememberMe');
          localStorage.removeItem('rememberId');
        }
        this.gotoMain();
      }
    },
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: 메인페이지로 이동 (go to main page)
     * since: 2023.05.12
     */
    gotoMain() {
      // this.$router.push({
      //   path: '/',
      // });
      // Do not use the router, because you need to bring the menu dynamically, reload it again with a token
      const redirect = this.$route.query.redirect || '';
      if (redirect) {
        window.location.href = `${this.$context}/?redirect=${redirect}`;
      } else {
        window.location.href = `${this.$context}/`;
      }
    },
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: 역할명 목록 조회(회원가입 시 역할 선택용) (get role list when signup)
     * since: 2023.05.12
     */
    getRoleList() {
      axios
        .get(`${SDLUtil.API_URL}/auth/noauth/roles`)
        .then(({ data }) => {
          // console.log(data);
          this.roleList = data;
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: AD, EpTray를 이용한 시스템 사용 신청 (register with AD, EpTray)
     * since: 2023.05.12
     */
    signonReg() {
      const chkRoleList = [];
      this.roleList.forEach(role => {
        if (role.selected) chkRoleList.push(role.roleName);
      });
      if (chkRoleList.length === 0) {
        SDLUtil.alert('sdl.common.message.checkRoleUser');
        return;
      }
      axios
        .post(
          `${SDLUtil.API_URL}/auth/noauth/user-reg-integration?roleList=${encodeURIComponent(
            chkRoleList.join(','),
          )}&jwtData=${encodeURIComponent(this.errorState.message)}`,
        )
        // eslint-disable-next-line no-unused-vars
        .then(({ response }) => {
          this.$store.commit('ERROR_STATE', {
            code: '191',
            reason: SDLUtil.getMsgProp('sdl.auth.message.user.waiting'),
          });
        })
        .catch(err => {
          console.error(err);
          SDLUtil.errorAlert(err);
        });
    },
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: SOC 연결 (connect SOC)
     * since: 2023.05.12
     */
    socConnect() {
      return new Promise(((resolve, reject) => {
        const server = new WebSocket('wss://localhost:29283');
        this.websocket = server;
        server.onopen = () => {
          server.send('{"rqtype":"getknoxsso","token":"","data":"KCC60TRAY0072"}');
          server.onmessage = (event) => {
            const socketData = JSON.parse(event.data);
            if (socketData.rpcode === 'RETURN_SUCCESS') {
              resolve(JSON.parse(socketData.data));
            } else {
              this.websocket.close();
              let err;
              if (socketData.rpcode === 'EMPTY_BOX') err = 'sdl.epTray.rpCode.EMPTY_BOX';
              else err = `sdl.epTray.rpCode.${socketData.detail}`;
              reject(err);
            }
          };
        };
        server.onerror = () => {
          const err = 'sdl.epTray.rpCode.CONNECTION_FAILED';
          reject(err);
        };
      }));
    },
  },
  watch: {
    errorState() {
      if (this.errorState.code === '196') {
        this.isLoaderVisible = false;
        this.getRoleList();
        // } else if (this.errorState.code === '191') {
        //   SDLUtil.alert(this.errorState.reason);
      } else if (this.errorState.code !== 'authOk') {
        if (this.errorState.code === '185' || this.errorState.code === '190') {
          this.isLoaderVisible = false;
          SDLUtil.alert(this.errorState.reason);
        } else {
          document.location = `${SDLUtil.WEB_CONTEXT_PATH}/warning?code=${this.errorState.code}`;
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      errorState: 'getErrorState',
    }),
  },
  created() {
    document.querySelector('body').classList.remove('register-wrap');
    document.querySelector('body').classList.add('ui--login-wrap');
    // this.logout();
    const rememberMe = localStorage.getItem('rememberMe');
    if (rememberMe === 'true') {
      this.rememberMe = true;
      this.userId = localStorage.getItem('rememberId');
    }

    // for AdLogin RegistrationException
    if (this.$route.query.code) {
      this.$store.commit('ERROR_STATE', {
        code: this.$route.query.code,
        message: this.$route.query.message,
      });
    }
  },
  mounted() {
    if (SDLUtil.isLogin()) {
      this.gotoMain();
    } else if (this.$route.query.token && this.$route.query.refreshToken) {
      loginService.setRefreshToken(this.$route.query.refreshToken);
      loginService.setToken(this.$route.query.token);
      this.gotoMain();
    } else {
      localStorage.removeItem('userToken');
      localStorage.removeItem('refreshToken');
      this.isLoaderVisible = false;
      MFAUtil.removeMFAToken();
      this.loginByAd();
    }

    if (this.$route.params.userId) {
      // Automatically enter the ID you entered when you passed the membership registration
      this.password = '';
      this.userId = this.$route.params.userId;
    }
  },
};
</script>
<style>
.loader {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/view/admin/main/LoginPage.vue